module.exports = __webpack_public_path__ + "img/slide_4.945ce18d.png";